import { compose, prop, converge, always, ifElse } from 'ramda';

import {
  FAN,
  PREMIUM,
  PREMIUM_PLUS,
  SUPER_FAN,
} from 'app/features/user/constants/accessTypes';
import { userAccessType } from 'app/features/user/selectors';
import { isCampaignSuccessRoute } from 'app/router/selectors';

const successState = prop('success');

const successOrganic = compose(prop('organic'), successState);
const successCampaign = compose(prop('campaign'), successState);

const success = ifElse(isCampaignSuccessRoute, successCampaign, successOrganic);

const pageTitle = converge(prop, [
  userAccessType,
  always({
    [PREMIUM]: 'success_meta_title_premium',
    [PREMIUM_PLUS]: 'success_meta_title_premium',
    [FAN]: 'success_meta_title_fanpack',
    [SUPER_FAN]: 'success_meta_title_super_fanpack',
  }),
]);

export { success, pageTitle };
